/** Extract file extension from a URL or path (e.g. ".docx" from "uploads/foo/bar.docx"). */
export const getExtensionFromUrl = (urlOrPath: string): string => {
    const path = urlOrPath.split('?')[0].split('#')[0];
    const match = path.match(/\.([a-zA-Z0-9]+)$/);
    return match ? `.${match[1].toLowerCase()}` : '';
};

export const downloadFileFromUrl = async (url: string, filename: string) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        throw error;
    }
};
